<template>
  <InformationItem v-bind="$props" :items="formattedItems" compact="true">
    <template v-slot:title>Dates</template>
  </InformationItem>
</template>

<script>
import InformationItem from './InformationItem';

export default {
  components: { InformationItem },
  props: ['items', 'itemType'],
};
</script>
